import initialState from './initialState'
import { SET_JOB_IN_DRAFT, REFRESH_JOB_IN_DRAFT } from '../actions/actionsTypes'

export default function jobDraft(state=initialState.jobDraft, action){
    let newState
    switch(action.type){
        case SET_JOB_IN_DRAFT:
            newState = action.payload ? action.payload: {}
            return newState
        case REFRESH_JOB_IN_DRAFT:
             return action.payload?.jobDraft ?? state
        default:
            return state
    }
}